import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bold',
  standalone: true,
})
export class BoldPipe implements PipeTransform {
  transform(value: string, searchText: string | null): string {
    if (!searchText) return value;
    const re = new RegExp(searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
    const match = value.match(re);
    if (!match) return value;
    return value.replace(re, `<b class="font-medium">${match[0]}</b>`);
  }
}
